const ToogleSidebarLightIcon = ({
    size = 24,
    strokeWidth = 1.5,
    strokeColor = '#3564D9',
    borderColor = '#E2E5E9',
    backgroundColor = 'white',
    ...props
}) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill={backgroundColor} />
        <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke={borderColor} />
        <path
            d="M10 16L14 12L10 8"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ToogleSidebarLightIcon
